<template>
	<div>
		<!-- <el-row style="">
			<el-breadcrumb separator="/" style="margin-top: 10px;margin-left: 20px;">
				<el-breadcrumb-item>设备管理</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/front/device/template' }">设备模版</el-breadcrumb-item>
				<el-breadcrumb-item>变量列表</el-breadcrumb-item>
			</el-breadcrumb>
		</el-row> -->
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span>模版信息</span>
			</div>
			<el-form class="text item" :inline="true" :model="templateAddOrUpdateForm" :rules="templateRules" ref="templateAddOrUpdateForm" label-width="120px">
				<el-form-item label="模版名称" prop="title"><el-input type="text" v-model="templateAddOrUpdateForm.title"></el-input></el-form-item>
			</el-form>
		</el-card>

		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span>变量列表</span>
			</div>
			<el-row class="contents">
				<!-- 查询条件 -->
				<el-col :span="24" class="handleQuery">
					<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="78px">
						<el-form-item label="变量名称"><el-input v-model="queryParams.title" placeholder="请输入变量名称"></el-input></el-form-item>
						<el-form-item label="变量分组">
							<el-select v-model="queryParams.tags" filterable placeholder="请选择变量分组">
								<el-option label="全部" value=""></el-option>
								<el-option :key="tag" :label="tag" :value="tag" v-for="tag in allTags"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" size="small" @click="handleQuery" :disabled="this.queryParams.templateId==null">查询</el-button>
							<el-button type="primary" size="small" @click="handleShowAdd" v-has="'btn_add'">添加变量</el-button>
							<el-button type="mini" size="primary" @click="handleShowImport()" v-has="'btn_import'">导入变量</el-button>
							<el-button type="mini" size="primary" @click="downloadVariable()">导出变量</el-button>
							<el-button type="mini" size="primary" @click="handleSort">排序</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<!-- 列表 -->
				<el-col :span="24">
					<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark"
						@selection-change="handleSelectionChange" @sort-change="sortChange" :default-sort="queryParams.defaultSort">
						<el-table-column fixed type="selection" width="55"></el-table-column>
						<el-table-column label="序号" width="60" align="right">
							<template slot-scope="scope">
								<span class="icon iconfont icon-shuidi" style="color:#409EFF" v-if="scope.row.isDrip"></span>
								<span class="icon iconfont icon-baojing1" style="color:#409EFF" v-if="scope.row.isAlarm"></span>
								{{ scope.$index + 1 }}
							</template>
						</el-table-column>
						<el-table-column prop="title" label="变量名称"></el-table-column>
						<el-table-column prop="dataType" label="数值类型"></el-table-column>
						<el-table-column prop="register" label="寄存器">
							<template slot-scope="scope">
								{{scope.row | formatRegister}}
							</template>
						</el-table-column>
						<el-table-column prop="readWriteType" label="读写方式">
							<template slot-scope="scope">
								{{scope.row.readWriteType | formatReadWriteType}}
							</template>
						</el-table-column>
						<el-table-column prop="saveType" label="存储方式">
							<template slot-scope="scope">
								{{scope.row.saveType | formatSaveType}}
							</template>
						</el-table-column>
						<el-table-column prop="tags" label="变量分组">
							<template slot-scope="scope" v-if="scope.row.tags">
								<el-tag v-for="(tag,index) in JSON.parse(scope.row.tags)" :key="index" type="">
									{{tag}}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="操作" :width="width" v-if="!showSort && width>0 ">
							<template slot-scope="scope">
								<el-button size="mini" type="text" @click="handleEdit(scope.row)" v-if="hasAuth('btn_edit')">编辑</el-button>
								<el-button size="mini" type="text" @click="handleSetSpecial(scope.row)" v-if="hasAuth('btn_drip')">设为特殊变量</el-button>
								<el-button size="mini" type="text" @click="handleAddTrigger(scope.row)" v-has="'btn_add_trigger'">添加触发器</el-button>
								<el-button size="mini" type="text" @click="goTriggerDetail(scope.row)" v-has="'btn_detail_trigger'">查看触发器</el-button>
								<el-button size="mini" type="text" @click="handleTranslate(scope.row)" v-has="'btn_translate'">变量值翻译</el-button>
								<el-button size="mini" type="text" @click="batchUpdateStatus(-1,'删除',scope.row.id)" v-has="'btn_del'">删除</el-button>
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="操作" :width="getWidth()" v-if="showSort">
							<template slot-scope="scope">
								<el-button size="mini" type="text" key="top" @click="toSort(scope.row,0,scope.$index)">置顶</el-button>
								<el-button size="mini" type="text" key="up" @click="toSort(scope.row,1,scope.$index)">上移</el-button>
								<el-button size="mini" type="text" key="down" @click="toSort(scope.row,2,scope.$index)">下移</el-button>
								<el-button size="mini" type="text" key="top" @click="toSort(scope.row,3,scope.$index)">置底</el-button>
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
						:age-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>

				</el-col>

				<el-col :span="24" class="more">
					<el-button size="small" type="primary" @click="handleSaveTemplate">完成</el-button>
				</el-col>
			</el-row>
		</el-card>

		<!-- 添加/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
			<el-form :inline="false" :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="120px" size="mini">
				<el-row>
					<el-col :span="12">
						<el-form-item label="变量名称" prop="title"><el-input type="text" v-model="addOrUpdateForm.title" :clearable="true"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="变量单位" prop="unit"><el-input type="text" v-model="addOrUpdateForm.unit" :clearable="true"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="变量标识符" prop="mark"><el-input type="text" v-model="addOrUpdateForm.mark" :clearable="true"></el-input></el-form-item>
				<el-form-item label="寄存器" required>
					<el-row>
						<el-select v-model="addOrUpdateForm.registerType" placeholder="请选择寄存器类型" style="width: 180px;">
							<el-option label="4" :value="4"></el-option>
						</el-select>
						<el-form-item prop="primaryAddress" style="display: inline-block;margin-bottom: 0px;">
							<el-input-number style="width:180px" type="number" v-model="addOrUpdateForm.primaryAddress" :controls="false" :min="1" :max="65536"
								:clearable="true"></el-input-number>
						</el-form-item>
						<el-form-item prop="secondaryAddress" style="display: inline-block;margin-bottom: 0px;" v-if="addOrUpdateForm.dataType=='bit'">
							<el-input-number type="number" v-model="addOrUpdateForm.secondaryAddress" :controls="false" :min="0" :max="15" :clearable="true"></el-input-number>
						</el-form-item>
						<span
							style="margin-left: 12px;color:cornflowerblue;font-size: 14px;position: relative;top: 2px;">{{addOrUpdateForm|formatRegister}}({{addOrUpdateForm.dataType}})</span>
					</el-row>
				</el-form-item>
				<el-form-item label="数据格式" prop="dataType">
					<el-select v-model="addOrUpdateForm.dataType" placeholder="请选择数据格式">
						<el-option label="16位 有符号" value="short"></el-option>
						<el-option label="16位 无符号" value="ushort"></el-option>
						<el-option label="32位 无符号" value="long"></el-option>
						<el-option label="32位 浮点数" value="float"></el-option>
						<el-option label="位" value="bit"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="采集频率" prop="rate">
					<el-select v-model="addOrUpdateForm.rate" placeholder="请选择频率">
						<el-option label="不采集(主动上报)" :value="0"></el-option>
						<el-option label="1分钟" :value="1"></el-option>
						<el-option label="3分钟" :value="3"></el-option>
						<el-option label="5分钟" :value="5"></el-option>
						<el-option label="10分钟" :value="10"></el-option>
						<el-option label="15分钟" :value="15"></el-option>
						<el-option label="20分钟" :value="20"></el-option>
						<el-option label="30分钟" :value="30"></el-option>
						<el-option label="1小时" :value="60"></el-option>
						<el-option label="5小时" :value="300"></el-option>
						<el-option label="1天" :value="1440"></el-option>
						<el-option label="5天" :value="7200"></el-option>
						<el-option label="15天" :value="21600"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="数字格式" v-if="addOrUpdateForm.dataType!='bit'" prop="scale">
					<el-select v-model="addOrUpdateForm.scale" placeholder="请选择数据格式">
						<el-option label="整数" :value="0"></el-option>
						<el-option label="保留1位小数" :value="1"></el-option>
						<el-option label="保留2位小数" :value="2"></el-option>
						<el-option label="保留3位小数" :value="3"></el-option>
						<el-option label="保留全部位小数" value=""></el-option>
					</el-select>
					<el-checkbox v-model="addOrUpdateForm.isThousandth">千分位</el-checkbox>
					<el-checkbox v-model="addOrUpdateForm.scaleCompletion" v-if="[1,2,3].includes(addOrUpdateForm.scale)">小数位补齐
						<el-tooltip placement="top" effect="dark">
							<div slot="content" style="width:300px">“小数位数补齐”是指在处理浮点数或带小数的数字时，通过在小数点后面添加零，来确保所有数字的小数位数达到预期的一致长度，从而满足一些特定的业务场景。<br />
								举例：<br />
								假设我们有以下数值，小数位数选择保留“2位”：<br />
								3.5、2.567、100<br />
								“小数位数补齐”勾选前，展示为：<br />
								3.5、2.57、100<br />
								“小数位数补齐”勾选后，展示为：<br />
								3.50、2.57、100.00'
							</div>
							<i class="el-icon-question"></i>
						</el-tooltip>
					</el-checkbox>
				</el-form-item>

				<el-form-item label="存储方式" prop="saveType">
					<el-radio-group v-model="addOrUpdateForm.saveType">
						<el-radio label="change">变化存储</el-radio>
						<el-radio label="all">全部存储</el-radio>
					</el-radio-group>
					</el-select>
				</el-form-item>
				</el-form-item>
				<el-form-item label="读写方式" prop="readWriteType">
					<el-radio-group v-model="addOrUpdateForm.readWriteType">
						<el-radio label="read_write">读写</el-radio>
						<el-radio label="read_only">只读</el-radio>
					</el-radio-group>
					</el-select>
				</el-form-item>
				<el-form-item label="采集公式" prop="collectFormula">
					<el-input type="text" v-model="addOrUpdateForm.collectFormula" :clearable="true"></el-input>
					<template slot="label">
						{{'采集公式'}}<el-tooltip placement="top" effect="dark">
							<div slot="content" style="width:220px">
								设备上行数据经采集公式计算后显示 。<br />
								公式中的%s为占位符，是固定字段。<br />
								如：<br />
								加：%s+10<br />
								减：%s-10<br />
								乘：%s*10<br />
								除：%s/10<br />
								余数：%s%10
							</div>
							<i class="el-icon-question"></i>
						</el-tooltip>
					</template>
				</el-form-item>
				<el-form-item label="控制公式" prop="controlFormula">
					<template slot="label">
						{{'控制公式'}}<el-tooltip placement="top" effect="dark">
							<div slot="content" style="width:240px;">
								主动向设备写数据经控制公式计算后下发 。<br />
								公式中的%s为占位符，是固定字段。<br />
								如：<br />
								加：%s+10<br />
								减：%s-10<br />
								乘：%s*10<br />
								除：%s/10<br />
								余数：%s%10
							</div>
							<i class="el-icon-question"></i>
						</el-tooltip>
					</template>
					<el-input type="text" v-model="addOrUpdateForm.controlFormula" :clearable="true"></el-input>
				</el-form-item>
				<el-form-item label="变量分组" prop="tags">
					<el-input type="text" v-model="addOrUpdateForm.tag" placeholder="请输入变量分组,按enter键自动创建" @keyup.enter.native="handleEnter"></el-input>
					<el-tag v-for="(tag,index) in tags" :key="index" closable type="" @close="handleRemoveTag(tag)" style="margin-top: 5px;">
						{{tag}}
					</el-tag>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>


		<el-dialog title="导入变量" :visible.sync="dialogVariableVisible" width="600px" :close-on-click-modal="false" :before-close="closeImport">
			<el-form :inline="false" :model="importForm" :rules="importRules" ref="importForm" label-width="120px">
				<el-form-item label="变量文件" prop="fileList">
					<el-upload class="upload-demo" ref="upload" action="/api/template/variable/import" :auto-upload="false" :multiple="false" :limit="2" accept=".xls, .xlsx"
						:headers="headers" :data="importData" :file-list="importForm.fileList" :on-change="onUploadChange" :on-remove="onUploadRemove" :before-upload="beforeUp"
						:on-success="onUploadSuccess">
						<el-button slot="trigger" size="small" type="primary">选取文件</el-button>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeImport()">取 消</el-button>
				<el-button size="small" type="primary" @click="handleImport">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="设置特殊变量" :visible.sync="dialogSetSpecial" width="600px" :close-on-click-modal="false">
			<el-radio-group v-model="radio" style="width:100%">
				<el-table :data="specialList" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" align="center">
					<el-table-column prop="title" label="特殊变量名称" align="center"></el-table-column>
					<el-table-column prop="tags" label="设置变量" align="center">
						<template slot-scope="scope">
							<el-radio :label="scope.row.type" @click.native.prevent="toggleRadio(scope.row.type)"><span style="display: none;" ></span></el-radio>
						</template>
					</el-table-column>
				</el-table>
			</el-radio-group>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogSetSpecial=false">取 消</el-button>
				<el-button size="small" type="primary" @click="saveSpecial">确 定</el-button>
			</div>
		</el-dialog>

		<templateTriggerAdd :dialogVisible.sync="dialogAddTriggerVisible" :addOrUpdateForm="addOrUpdateForm" title="添加触发器"></templateTriggerAdd>

		<variableTranslate ref="variableTranslate" :dialogListVisible.sync="dialogListVisible" :params="translateParams" title="变量值翻译"></variableTranslate>



	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';
	import templateTriggerAdd from '@/components/layout/devices/templateTriggerAdd';
	import variableTranslate from '@/components/layout/devices/variableTranslate';
	import common from '@/common/common.js';
	import axios from 'axios'

	export default {
		extends: BaseSearch,
		components: {
			templateTriggerAdd,
			variableTranslate
		},
		data() {
			return {
				specialList: [],
				radio: '',
				specialVariableId:'',
				templateRules: {
					title: [{
							required: true,
							message: '请输入模版名称',
							trigger: 'blur'
						},
						{
							max: 50,
							message: '长度最长支持50',
							trigger: 'blur'
						}
					]
				},
				templateAddOrUpdateForm: {
					id: null,
					title: ""
				},
				queryParams: {
					defaultSort: {
						order: null,
						prop: ''
					}
				},
				dialogAddTriggerVisible: false,
				dialogListVisible: false,
				dialogSetSpecial: false,
				translateParams: {},
				allTags: [],
				tags: [],
				hashBack: false,
				url: 'template/variable',
				name: '变量',
				dialogVariableVisible: false,
				importData: {},
				importForm: {
					fileList: []
				},
				headers: {},
				intervalId: null,
				row: {},
				dialogBatchSendVisible: false,
				variableValues: [],
				groupList: [],
				currGroup: null,
				importRules: {
					fileList: [{
						required: true,
						message: '请选择文件',
						trigger: 'blur',
						validator: this.checkFileNotEmpty,
					}]
				},
				rules: {
					title: [{
							required: true,
							message: '请输入变量名称',
							trigger: 'blur'
						},
						{
							max: 50,
							message: '变量名称长度最长支持50',
							trigger: 'blur'
						}
					],
					dataType: [{
						required: true,
						message: '请选择数据格式',
						trigger: 'blur'
					}],
					primaryAddress: [{
							type: 'number',
							required: true,
							message: '寄存器地址错误，范围1-65536',
							trigger: 'blur'
						},
						{
							min: 1,
							type: 'number',
							message: '寄存器地址错误，范围1-65536',
							trigger: 'blur'
						},
						{
							max: 65536,
							type: 'number',
							message: '寄存器地址错误，范围1-65536',
							trigger: 'blur'
						}
					],
					secondaryAddress: [{
							type: 'number',
							required: true,
							message: '位地址错误，范围0-15',
							trigger: 'blur'
						},
						{
							min: 0,
							type: 'number',
							message: '位地址错误，范围0-15',
							trigger: 'blur'
						},
						{
							max: 15,
							type: 'number',
							message: '位地址错误，范围0-15',
							trigger: 'blur'
						}
					],
					scale: [{
						required: true,
						message: '请选择数字格式',
						trigger: 'blur'
					}],
					saveType: [{
						required: true,
						message: '请选择存储方式',
						trigger: 'blur'
					}],
					rate: [{
						required: true,
						message: '请选择采集频率',
						trigger: 'blur'
					}],
					readWriteType: [{
						required: true,
						message: '请选择读写方式',
						trigger: 'blur'
					}]
				},
				loading: false,
				autoQuery: false,
				showSort: false,
			};
		},
		filters: {
			formatSaveType(dataType) {
				if ("change" == dataType) {
					return "变化存储";
				} else {
					return "全部存储"
				}
			},
			formatRate(rate) {
				if (rate >= 60 * 24) {
					return (rate / 60 / 24) + "天"
				} else {
					return rate + "分钟"
				}
			},
			formatReadWriteType(readWriteType) {
				if ("read_only" == readWriteType) {
					return "只读";
				} else if ("read_write" == readWriteType) {
					return "读写";
				}
				return "";
			},
			formatReceiveData(row) {
				if (row.status == 0) {
					return "未开始"
				} else if (row.status == 1) {
					return "获取中..."
				} else {
					return row.receiveData
				}
			},
			formatRegister(row) {
				if (!row.primaryAddress) {
					return row.registerType
				} else {
					var register = "";
					if ((row.primaryAddress + "").length < 4) {
						register = row.registerType * 1000 + row.primaryAddress
					} else {
						register = row.registerType + "" + row.primaryAddress
					}
					if (row.dataType == 'bit') {
						register += "."
						if (row.secondaryAddress) {
							register += row.secondaryAddress
						}
					}
					return register
				}
			}
		},
		methods: {
			toggleRadio(value) {
				if (this.radio === value) {
					this.radio = ""; // 取消选中
				} else {
					this.radio = value; // 选中
				}
			},
			checkFileNotEmpty(rule, value, callback) {
				var list = this.$refs.upload.uploadFiles
				if (list && list.length > 0) {
					callback();
				} else {
					callback(new Error(rule.message));
				}
			},
			getWidth() {
				if (this.width > 140) {
					return this.width - 1
				}
				return 140
			},
			handleSaveTemplate() {
				this.saveTemplate((isAdd) => {
					if (isAdd) {
						this.successMessage('添加成功', '您成功添加一条数据');
					} else {
						this.successMessage('系统提示', '修改成功');
					}
				})
			},
			getTemplate() {
				let that = this;
				this.$http({
					method: 'GET',
					url: 'template/detail?id=' + this.templateAddOrUpdateForm.id,
					data: {},
				}).then(function(res) {
					that.device = res.data.data;
					that.templateAddOrUpdateForm.title = res.data.data.title;
				})
			},
			saveTemplate(callback) {
				this.$refs['templateAddOrUpdateForm'].validate(valid => {
					if (valid) {
						this.beforeUpdate();
						let that = this;
						let url = '/create';
						if (that.templateAddOrUpdateForm.id) {
							url = '/update';
						}
						this.$http({
							method: 'POST',
							url: '/template/' + url,
							data: that.templateAddOrUpdateForm
						}).then((res) => {
							if (res.data.errorCode == '0000') {
								if (callback) {
									var isAdd = that.templateAddOrUpdateForm.id == null
									if (isAdd) {
										that.templateAddOrUpdateForm.id = res.data.data
										that.queryParams.templateId = res.data.data
										common.routerReplace(this, '/front/device/templateVariable', {
											templateId: that.templateAddOrUpdateForm.id
										})
									}
									callback(isAdd)
								}
							}
						})
					}
				});
			},
			handleSetDrip(row, isDrip) {
				this.$http({
					method: 'POST',
					url: '/template/variable/updateDrip',
					data: {
						id: row.id,
						isDrip: isDrip
					}
				}).then((res) => {
					this.getList();
				})
			},
			handleSetSpecial(row) {
				var that = this;
				this.$http({
					method: 'GET',
					url: '/template/variable/querySpecialList?id=' + row.id,
				}).then((res) => {
					this.specialVariableId=row.id;
					this.specialList = res.data.data;
					that.radio=""
					res.data.data.forEach(item => {
						if (item.isChecked) {
							that.radio = item.type
							return true;
						}
					});
					this.dialogSetSpecial = true;
				})
			},
			saveSpecial(){
				this.$http({
					method: 'GET',
					url: '/template/variable/saveSpecial?id=' + this.specialVariableId+"&type="+this.radio,
				}).then((res) => {
					this.dialogSetSpecial = false;
					this.getList();
				})
			},
			goTriggerDetail(row) {
				common.routerPush(this, '/front/template/trigger', {
					templateId: row.templateId,
					templateTitle: row.templateTitle,
					variableId: row.id,
					variableTitle: row.title,
				})
			},
			handleTranslate(row) {
				this.translateParams.variableId = row.id
				this.translateParams.variableTitle = row.title
				this.dialogListVisible = true
				this.$refs.variableTranslate.handleQuery();
			},
			handleAddTrigger(data) {
				this.addOrUpdateForm = {
					templateId: data.templateId,
					templateTitle: data.templateTitle,
					variableId: data.id,
					variableTitle: data.title
				};
				this.dialogAddTriggerVisible = true
			},
			onUploadChange(file, list) {
				console.log('onUploadChange', list.length)
				if (list.length > 1 && file.status !== "fail" && file.status !== "success") {
					list.splice(0, 1);
					this.importForm.fileList = list
					this.$refs['importForm'].clearValidate();
				} else if (file.status === "success") {
					file.status = 'ready'
					this.importForm.fileList = list
					this.$refs['importForm'].clearValidate();
				}
			},
			onUploadRemove(file, list) {
				console.log('onUploadRemove', file)
				this.importForm.fileList = list
			},
			beforeUp(file) {
				var accept = file.name.substring(file.name.lastIndexOf(".") + 1)
				const isH5 = accept === "xls" || accept === "xlsx";
				const isLt2G = file.size / 1024 / 1024 / 1024 < 2;
				if (!isH5) {
					this.errorMessage('系统提示', "仅支持上传.xls .xlsx 文件");
				}
				if (!isLt2G) {
					this.errorMessage('系统提示', "上传文件大小不能超过 2G!");
				}
				return isH5 && isLt2G;
			},
			onUploadSuccess(response, file, fileList) {
				if (response.success) {
					this.queryTags()
					this.handleQuery()
					this.closeImport()
					this.successMessage('系统提示', "导入成功");
				} else {
					this.errorMessage('导入失败', response.message);
				}
			},
			afterUpdate() {
				this.queryTags()
			},
			handleShowAdd() {
				this.saveTemplate((isAdd) => {
					this.handleAdd();
				})
			},
			handleShowImport() {
				this.saveTemplate((isAdd) => {
					this.importData.templateId = this.queryParams.templateId
					this.dialogVariableVisible = true
				})
			},
			handleSort() {
				this.showSort = !this.showSort;
			},
			toSort(row, action, index) {
				this.$http({
						method: 'POST',
						url: 'template/variable/order/update',
						data: {
							templateId: this.queryParams.templateId,
							action: action,
							variableId: row.id,
							orderBy: row.orderBy
						}
					})
					.then(() => {
						if (index == 0 || action == 0) {
							if (this.queryParams.currentPage > 1) {
								this.queryParams.currentPage = this.queryParams.currentPage - 1;
							}
						}
						this.getList();
					})
			},
			closeImport(done) {
				this.importForm.fileList = []
				this.$refs['importForm'].resetFields();
				if (done) {
					done();
				} else {
					this.dialogVariableVisible = false
				}
			},
			handleImport() {
				console.log('submit', this.$refs.upload.uploadFiles.length)
				this.$refs['importForm'].validate(valid => {
					if (valid) {
						this.$refs.upload.submit();
					}
				});
			},
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {};
				}
			},
			beforeUpdate() {
				this.addOrUpdateForm.templateId = this.queryParams.templateId;
				this.addOrUpdateForm.tags = JSON.stringify(this.tags);
				if (this.addOrUpdateForm.dataType != 'bit') {
					this.addOrUpdateForm.secondaryAddress = null
				}
				if (![1, 2, 3].includes(this.addOrUpdateForm.scale)) {
					this.addOrUpdateForm.scaleCompletion = false
				}
			},
			handleEnter() {
				if (this.addOrUpdateForm.tag) {
					if (this.tags.indexOf(this.addOrUpdateForm.tag) == -1) {
						this.tags.push(this.addOrUpdateForm.tag)
						this.addOrUpdateForm.tag = ""
					} else {
						this.$message({
							message: '变量分组' + this.addOrUpdateForm.tag + '已存在',
							type: 'warning'
						});
					}
				}
			},
			handleRemoveTag(tag) {
				this.tags.splice(this.tags.indexOf(tag), 1);
			},
			getAddData() {
				return {
					dataType: "ushort",
					registerType: 4,
					rate: 5,
					scale: 0,
					saveType: 'change',
					readWriteType: 'read_only',
					scaleCompletion: false,
					isThousandth: false
				}
			},
			beforeEdit(isEdit) {
				this.tags = []
				if (this.addOrUpdateForm.tags) {
					this.tags = JSON.parse(this.addOrUpdateForm.tags)
				}
			},
			queryTags() {
				this.$http({
					method: 'POST',
					url: 'template/variable/queryTags?templateId=' + this.queryParams.templateId,
					data: {},
				}).then((res) => {
					this.allTags = res.data.data;
				})
			},
			downloadVariable() {
				this.queryParams.templateTitle = this.templateAddOrUpdateForm.title;
				this.$http({
						method: 'POST',
						url: '/template/variable/export',
						data: this.queryParams,
						responseType: 'arraybuffer'
					})
					.then(response => {
						const blob = new Blob([response.data], {
							type: response.headers['content-type']
						});
						const url = window.URL.createObjectURL(blob);
						const a = document.createElement('a');
						a.href = url;
						a.download = decodeURIComponent(response.headers['content-disposition'].split(';')[1].split('=')[1]) || 'default.txt';
						a.click();
						window.URL.revokeObjectURL(url);
					})
			}
		},
		mounted: function() {
			if (this.$route.query.templateId) {
				this.hashBack = true;
				this.queryParams.templateId = this.$route.query.templateId;
				this.addOrUpdateForm.templateId = this.$route.query.templateId;
				this.templateAddOrUpdateForm.id = this.$route.query.templateId;
				this.getTemplate()
				this.queryTags();
				this.handleQuery();
			}
			let token = sessionStorage.getItem('token');
			this.headers.Token = token;
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}

	.el-tag {
		margin: 0px 8px 5px 0px;
		padding: 0 5px;
	}

	.box-card {
		margin: 10px 20px 0px 20px;
	}

	.more {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 60px;
	}

	/deep/ .el-dialog__body {
		padding: 0px 20px;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/device/templateVariable.vue